// Inicialización segura con Turbolinks
document.addEventListener('turbolinks:load', () => {
  // Inicializa cualquier carrusel con la clase .js-slick que aún no esté inicializado
  $('.js-slick').not('.slick-initialized').slick({
    dots: true,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } }
    ]
  });
});

// Limpieza antes de que Turbolinks cachee la página
document.addEventListener('turbolinks:before-cache', () => {
  $('.js-slick.slick-initialized').slick('unslick');
});